/**
 * Normalise une meta description pour rester dans la fenêtre affichée par Google
 * (140 à 158 caractères) sans couper au milieu d'un mot.
 */
const MIN = 140;
const MAX = 158;

const FILLERS = [
  "Devis gratuit en 24 h.",
  "Vaucluse, Luberon et Provence.",
  "DJ Val, 20 ans d'expérience.",
];

export function metaDesc(input: string, extra?: string): string {
  let text = String(input ?? "").replace(/\s+/g, " ").trim();

  // Trop long : on coupe à la dernière phrase complète, sinon au dernier mot.
  if (text.length > MAX) {
    const window = text.slice(0, MAX + 1);
    const sentence = Math.max(
      window.lastIndexOf(". "),
      window.lastIndexOf("! "),
      window.lastIndexOf("? "),
    );
    if (sentence >= MIN - 20) {
      text = window.slice(0, sentence + 1).trim();
    } else {
      const cut = window.slice(0, MAX).lastIndexOf(" ");
      text = window.slice(0, cut > 0 ? cut : MAX).replace(/[ ,;:–-]+$/, "").trim();
      if (!/[.!?]$/.test(text)) text += ".";
    }
  }

  // Trop court : on complète avec des compléments utiles.
  const pool = extra ? [extra, ...FILLERS] : FILLERS;
  for (const filler of pool) {
    if (text.length >= MIN) break;
    if (text.includes(filler)) continue;
    const candidate = `${text.replace(/\s+$/, "")} ${filler}`.trim();
    if (candidate.length <= MAX) text = candidate;
  }

  return text;
}
